import React, { useState, useEffect } from 'react';
import { getAuth, onAuthStateChanged, signOut } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db, appId } from './firebase';

import LoginPage from './components/LoginPage';
import Sidebar from './components/Sidebar';
import Header from './components/Header'; 
import MainContent from './components/MainContent';
import { Loader } from 'lucide-react';

const App = () => {
    const [authStatus, setAuthStatus] = useState({
        isLoading: true,
        user: null,
        userRole: null,
        isSuperAdmin: false, // Nuevo estado para el Superadmin
    });
    const [activePage, setActivePage] = useState('dashboard');
    const [isSidebarOpen, setSidebarOpen] = useState(false);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (user) => {
            if (user) {
                const path = `artifacts/${appId}/public/data/users`;
                const userDocRef = doc(db, path, user.uid);
                const userDocSnap = await getDoc(userDocRef);
                if (userDocSnap.exists()) {
                    const userData = userDocSnap.data();
                    setAuthStatus({ 
                        isLoading: false, 
                        user: user, 
                        userRole: userData.role,
                        isSuperAdmin: userData.isSuperAdmin === true // Verificamos si es Superadmin
                    });
                } else {
                     await signOut(auth);
                     setAuthStatus({ isLoading: false, user: null, userRole: null, isSuperAdmin: false });
                }
            } else {
                setAuthStatus({ isLoading: false, user: null, userRole: null, isSuperAdmin: false });
            }
        });
        return () => unsubscribe();
    }, []);

    const toggleSidebar = () => {
        setSidebarOpen(!isSidebarOpen);
    };

    if (authStatus.isLoading) {
        return (
            <div className="flex items-center justify-center min-h-screen">
                <Loader className="animate-spin text-blue-600" size={48} />
            </div>
        );
    }
    
    if (!authStatus.user) {
        return <LoginPage />;
    }

    return (
        <div className="flex h-screen bg-gray-100 font-sans">
            <Sidebar 
                userRole={authStatus.userRole} 
                activePage={activePage} 
                setActivePage={setActivePage}
                isOpen={isSidebarOpen}
                toggleSidebar={toggleSidebar}
            />
            <div className="flex-1 flex flex-col overflow-hidden">
                <Header 
                    page={activePage}
                    toggleSidebar={toggleSidebar}
                />
                <MainContent 
                    page={activePage} 
                    userRole={authStatus.userRole} 
                    currentUser={authStatus.user}
                    isSuperAdmin={authStatus.isSuperAdmin} // Pasamos la nueva propiedad
                />
            </div>
        </div>
    );
};

export default App;
